export const ROOM_TYPE_LIST = [
  {
    label: "Music Hall",
    value: "1",
  },
  {
    label: "Music Practice Room",
    value: "2",
  },
];

export const PAYMENT_STATUS = [
  {
    label: "Pending",
    value: "1",
  },
  {
    label: "Completed",
    value: "2",
  },
  {
    label: "Failed",
    value: "3",
  },
];

export const PAYMENT_METHOD = [
  {
    label: "บัตรเครดิต by Admin",
    value: "1",
  },
  {
    label: "โอนเงิน by Admin",
    value: "2",
  },
  {
    label: "อัพโหลสลิป by Customer",
    value: "3",
  },
  {
    label: "เงินสด by Admin",
    value: "4",
  },
];

export const ACKNOWLEDGED_STATUS = [
  {
    label: "รอแอดมินรับทราบ",
    value: "1",
  },
  {
    label: "แอดมินรับทราบแล้ว",
    value: "2",
  },
];

export const RENDER_ROOM_TYPE = (type) => {
  switch (type) {
    case "1":
      return {
        labelTh: "Music Hall",
      };
    case "2":
      return {
        labelTh: "Music Practice Room",
      };
    default:
      return {
        labelTh: "",
      };
  }
};

export const RENDER_BOOKING_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelEn: "Waiting Customer",
        customerLabelEn: "Draft",
        txtColor: "#000000",
        bgColor: "#D9D9D9",
        adminTodoEn: "Wait Customer to submit booking details",
        adminTodoColor: "#000000",
      };
    case "2":
      return {
        labelEn: "Waiting for Approved",
        customerLabelEn: "Waiting for Confirm from Admin",
        txtColor: "#4B1E78",
        bgColor: "#FFF500",
        adminTodoEn: "Admin check Form detail then ACCEPT or REJECT",
        adminTodoColor: "#FF0000",
      };
    case "3":
      return {
        labelEn: "Confirm Detail & Request Slip",
        customerLabelEn: "Please transfer and upload slip",
        txtColor: "#FFFFFF",
        bgColor: "#FF8900",
        adminTodoEn: "Admin APPROVED detail, waiting for SLIP",
        adminTodoColor: "#000000",
      };
    case "4":
      return {
        labelEn: "Waiting for Approved",
        customerLabelEn: "Booking Pending",
        txtColor: "#FFFFFF",
        bgColor: "#FF8900",
        adminTodoEn: "Admin go to confirm slip at “Transfer Slip” tab menu",
        adminTodoColor: "#FF0000",
      };
    case "5":
      return {
        labelEn: "Detail + Slip Approved ",
        customerLabelEn: "Booking success, waiting for event",
        txtColor: "#FFFFFF",
        bgColor: "#328826",
        adminTodoEn: "Booking success, waiting for event",
        adminTodoColor: "#000000",
      };
    case "6":
      return {
        labelEn: "Reject - Need More Info",
        customerLabelEn: "Booking Pending",
        txtColor: "#FFFFFF",
        bgColor: "#FF8900",
        adminTodoEn: "Admin rejected, ask customer for more info.",
        adminTodoColor: "#000000",
      };
    case "7":
      return {
        labelEn: "Reject - Need More Info",
        customerLabelEn: "Cancel Booking (by Customer)",
        txtColor: "#FFFFFF",
        bgColor: "#FF8900",
        adminTodoEn: "Booking Pending",
        adminTodoColor: "#000000",
      };
    case "8":
      return {
        labelEn: "Cancel Booking (by Admin)",
        customerLabelEn: "Cancel Booking (by Admin)",
        txtColor: "#FFFFFF",
        bgColor: "#FF0000",
        adminTodoEn: "Booking Cancelled by Admin",
        adminTodoColor: "#000000",
      };
    default:
      return {
        labelEn: "",
        customerLabelEn: "",
        txtColor: "#000000",
        bgColor: "#FFFFFF",
        adminTodoEn: "",
      };
  }
};

export const RENDER_BOOKING_EVENT_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelEn: "Waiting for event",
        txtColor: "#FFFFFF",
        bgColor: "#D9C316",
      };
    case "2":
      return {
        labelEn: "Checking before Close",
        txtColor: "#000000",
        bgColor: "#FFF500",
      };
    case "3":
      return {
        labelEn: "Closed - Success",
        txtColor: "#FFFFFF",
        bgColor: "#328826",
      };
    case "4":
      return {
        labelEn: "Closed - No Show",
        txtColor: "#FFFFFF",
        bgColor: "#FF0000",
      };
    case "5":
      return {
        labelEn: "N/A",
        txtColor: "#FFFFFF",
        bgColor: "#A9A9A9",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
        bgColor: "#FFFFFF",
      };
  }
};

// งานที่แอดมินต้องทำ แสดงในคอลัมน์ Event Status ก่อนจองสำเร็จ (ไม่ได้เก็บใน DB)
// value ต้องตรงกับที่ API แปลงใน roomBookingService.scopeSearch
export const BOOKING_ADMIN_TASK = [
  {
    label: "Confirm Booking",
    value: "confirm_booking",
    status: "2",
    txtColor: "#FFFFFF",
    bgColor: "#FF0000",
  },
  {
    label: "Verify Slip",
    value: "verify_slip",
    status: "4",
    txtColor: "#FFFFFF",
    bgColor: "#FF0000",
  },
  // รอลูกค้าโอน/อัปสลิป แอดมินยังไม่ต้องทำอะไร ใช้สีเทา (แดง = แอดมินต้องทำ)
  {
    label: "Wait for slip",
    value: "wait_for_slip",
    status: "3",
    txtColor: "#FFFFFF",
    bgColor: "#A9A9A9",
  },
];

export const RENDER_BOOKING_ADMIN_TASK = (status) =>
  BOOKING_ADMIN_TASK.find((e) => e.status === status);

// ยืนยันสลิปครบทุกใบหรือยัง (เช็ครายใบ ไม่ใช้ is_payments_all_acknowledged จาก API
// เพราะ API ตั้งเป็น true ตั้งแต่ยืนยันใบแรก แม้มีสลิปที่ลูกค้าอัปเพิ่มค้างอยู่)
export const IS_ALL_PAYMENTS_ACKNOWLEDGED = (payments) =>
  Array.isArray(payments) &&
  payments.length > 0 &&
  payments.every((p) => p.acknowledged_status === "2");

export const BOOKING_STATUS = [
  {
    label: "Draft",
    value: "1",
  },
  {
    label: "Waiting for Confirm from Admin",
    value: "2",
  },
  {
    label: "Confirm Detail & Request Slip",
    value: "3",
  },
  {
    label: "Waiting for Slip Confirmation from Admin",
    value: "4",
  },
  {
    label: "Detail + Slip Approved",
    value: "5",
  },
  {
    label: "Reject - Need More Info",
    value: "6",
  },
  {
    label: "Cancel Booking (by Customer)",
    value: "7",
  },
  {
    label: "Cancel Booking (by Admin)",
    value: "8",
  },
];

export const BOOKING_EVENT_STATUS = [
  {
    label: "Waiting for event",
    value: "1",
  },
  {
    label: "Checking before Close",
    value: "2",
  },
  {
    label: "Closed - Success",
    value: "3",
  },
  {
    label: "Closed - No Show",
    value: "4",
  },
  {
    label: "N/A",
    value: "5",
  },
];

export const RENDER_PAYMENT_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelTh: "รอชำระเงิน",
        txtColor: "#000000",
        bgColor: "#D9D9D9",
      };
    case "2":
      return {
        labelTh: "โอนสำเร็จ",
        txtColor: "#5CB719",
        bgColor: "#328826",
      };
    case "3":
      return {
        labelTh: "โอนไม่สำเร็จ",
        txtColor: "#FF0000",
        bgColor: "#FF0000",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
        bgColor: "#FFFFFF",
      };
  }
};

export const RENDER_PAYMENT_METHOD = (method) => {
  switch (method) {
    case "1":
      return {
        labelTh: "บัตรเครดิต by Admin",
        txtColor: "#5CB719",
        bgColor: "#328826",
      };
    case "2":
      return {
        labelTh: "โอนเงิน by Admin",
        txtColor: "#5CB719",
        bgColor: "#328826",
      };
    case "3":
      return {
        labelTh: "อัพโหลสลิป by Customer",
        txtColor: "#5CB719",
        bgColor: "#328826",
      };
    case "4":
      return {
        labelTh: "เงินสด by Admin",
        txtColor: "#5CB719",
        bgColor: "#328826",
      };
    default:
      return {
        labelTh: "",
      };
  }
};

export const RENDER_ACKNOWLEDGED_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelTh: "รอแอดมินรับทราบ",
        txtColor: "#222020",
        bgColor: "#EAAE28",
      };
    case "2":
      return {
        labelTh: "แอดมินรับทราบแล้ว",
        txtColor: "#222020",
        bgColor: "#94E559",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#222020",
        bgColor: "#FFFFFF",
      };
  }
};

export const RENDER_ACKNOWLEDGED_STATUS_ALL = (e) => {
  if (e) {
    return {
      labelTh: "แอดมินรับทราบแล้ว",
      txtColor: "#222020",
      bgColor: "#94E559",
    };
  } else {
    return {
      labelTh: "รอแอดมินรับทราบ",
      txtColor: "#222020",
      bgColor: "#EAAE28",
    };
  }
};

export const RENDER_EVENT_TYPE = (type) => {
  switch (type) {
    case "1":
      return {
        labelEn: "Concert",
      };
    case "2":
      return {
        labelEn: "Competition",
      };
    case "3":
      return {
        labelEn: "Recording",
      };
    case "4":
      return {
        labelEn: "Racital",
      };
    case "5":
      return {
        labelEn: "Rehearsal",
      };
    case "6":
      return {
        labelEn: "Master Class / Workshop",
      };
    case "7":
      return {
        labelEn: "Exhibitiont",
      };
    case "8":
      return {
        labelEn: "Seminar / Forum",
      };

    default:
      return {
        labelEn: "",
      };
  }
};

export const BOOKING_SOURCE = [
  {
    label: "Customer",
    value: "1",
  },
  {
    label: "Internal",
    value: "2",
  },
  {
    label: "Music Academy",
    value: "3",
  },
];

export const RENDER_BOOKING_SOURCE = (source) => {
  switch (source) {
    case "1":
      return {
        labelEn: "Customer",
        txtColor: "#0B50EB",
      };
    case "2":
      return {
        labelEn: "Internal",
        txtColor: "#4B1E78",
      };
    case "3":
      return {
        labelEn: "Music Academy",
        txtColor: "#FF0000",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
      };
  }
};

export const PAYMENT_METHOD_ADMIN = [
  {
    label: "โอนเงิน",
    value: "2",
  },
  {
    label: "บัตรเครดิต/เดบิต",
    value: "1",
  },
  {
    label: "เงินสด",
    value: "4",
  },
];

// สีของแต่ละ step ใช้ร่วมกันระหว่างวงกลม step (BookingStepWidget) กับเลข step บนปุ่ม Edit/Action
export const RENDER_BOOKING_STEP = (step) => {
  switch (Number(step)) {
    case 1:
      return { color: "yellow", bgColor: "#FFF500", txtColor: "#000000" };
    case 2:
      return { color: "orange", bgColor: "#FF8900", txtColor: "#000000" };
    case 3:
      return { color: "purple", bgColor: "#4B42A8", txtColor: "#FFFFFF" };
    case 4:
      return { color: "green", bgColor: "#3F830D", txtColor: "#FFFFFF" };
    default:
      return { color: "", bgColor: "#FFFFFF", txtColor: "#000000" };
  }
};

export const RENDER_BOOKING_STATUS_TO_STEP = (status) => {
  switch (status) {
    case "1":
    case "2":
      return 1;
    case "3":
      return 2;
    case "4":
      return 3;
    case "5":
      return 4;
    default:
      return "";
  }
};

// สีของ status การจอง ใช้ร่วมกันทั้งป้ายหน้า list, การ์ดในตาราง (Table) และคำอธิบายสีใต้ filter
// status "4" (step 3) ใช้สีม่วงของวงกลม step แทน เพราะสีใน RENDER_BOOKING_STATUS ซ้ำกับ status "3" (step 2)
export const RENDER_BOOKING_STATUS_COLOR = (status) => {
  const step = RENDER_BOOKING_STATUS_TO_STEP(status);
  const source =
    step === 3 ? RENDER_BOOKING_STEP(step) : RENDER_BOOKING_STATUS(status);
  return { bgColor: source.bgColor, txtColor: source.txtColor };
};

// ชื่อ status การจองที่แสดงบนป้ายหน้า list และคำอธิบายสีในหน้า Table (ใช้ตัวเดียวกันให้ตรงกัน)
// เช่น "2. Please transfer and upload slip" — มีเลข step นำหน้าเฉพาะ status ที่อยู่ใน step
export const RENDER_BOOKING_STATUS_LABEL = (status) => {
  const step = RENDER_BOOKING_STATUS_TO_STEP(status);
  return `${step ? `${step}. ` : ""}${
    RENDER_BOOKING_STATUS(status).customerLabelEn
  }`;
};
